<template lang="">
  <div class="bg-light-gray px-4 mb-2">
    <div class="row p-3">
      <div class="col-12 pl-0">
        <icon-view
          class="mt-4"
          :has-border="false"
          icon="fas fa-plus-circle text-orange pb-1"
          icon-size="17px"
          variant="custom-icon-view"
          icon-background="white"
          title="Solicitar por SIFDE"
        />
      </div>
    </div>
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 col-md-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              :options="options"
              label="Razón:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione una razón"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione una razón"
              :error="errors[0]"
              v-model="model.reason"
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="color-black font-16 my-1">
              Comentario de Solicitud:
            </div>
            <custom-text-area
              id="txtComment"
              v-model="model.comment"
              :count-classes="['d-block', 'small-counter', 'text-right']"
              custom-error-msg="Favor escriba un comentario"
              :error="errors[0]"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              show-char-count
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4 pb-3">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="handlerCancel"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Someter"
        variant="success px-3"
        @click="handlerSubmit"
      />
    </div>
  </div>
</template>
<script>
import IconView from 'icon-view';
import CustomTextArea from '@quisit/custom-text-area';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import reasonTypes from '@/utils/constants/reasonTypes';

export default {
  name: 'RequestSIFDE',
  components: {
    IconView,
    CustomTextArea,
    ActionButton,
    CustomDropDown,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    options: [],
  }),
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.getReasons();
  },
  methods: {
    handlerSubmit() {
      this.$refs.formModalObserver.validate().then((success) => {
        if (success) {
          this.$emit('submit', this.model);
        }
      });
    },
    handlerCancel() {
      this.model = {
        comment: null,
        reason: null,
      };
      this.$emit('cancel');
    },
    async getReasons() {
      const { data } = await referralAndEquipmentsservice.getReasonsByType(
        reasonTypes.SifdeRequest
      );
      this.options = data;
    },
  },
};
</script>
<style lang="scss"></style>
